import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import React from 'react'

export type Props = {
  right?: boolean
  extra?: any
  style?: { [key: string]: number }
  children: React.ReactNode
}

export const Header: React.FC<Props> = (props) => (
  <th
    className={props.right ? 'text-right' : undefined}
    style={props.style}
    css={css`
      border-bottom: 1px solid ${colors.border};
      display: table-cell;
      height: 40px;
      padding: 2px 8px;
      position: relative;
      color: ${colors.textStrong};
      font-size: 12px;
      font-weight: ${font.weight.bold};
      text-align: left;
    `}
  >
    <span>{props.children}</span>
    {props.extra}
  </th>
)
